module.exports = __webpack_public_path__ + "static/media/team-kpi.7507ecc9.svg";